/**
 * Function to check determine table level inventory access
 * 
 * @param {string} collectionid - Firestore collectionid
 * @param {useContext} getRoles - useContext(GetRoles);
 * @param {useContext} getUser - useContext(GetUser);
 * 
 * ```
 *  const collectionid = 'agreements';
 *  const getRoles = useContext(GetRoles);
 * const getUser = useContext(GetUser);
 * 
 *  const roleCheck = CheckInventoryRole(collectionid, getRoles, getUser);
 *  console.log('User has this inventory role:', roleCheck);
 * ```
 * 
 * Documentation
 * - N/A
 */

export default function CheckInventoryRole(collectionid, getRoles, getUser) {

  try {

    // Admin (read, download, create, write & delete access is implied)
    if (getRoles[collectionid]?.[getUser.emailaddress]?.admin || getRoles[collectionid]?.['allUsers']?.admin) {

      return 'admin';

    }

    // Delete (read, download, create & write access is implied)
    if (getRoles[collectionid]?.[getUser.emailaddress]?.delete || getRoles[collectionid]?.['allUsers']?.delete) {

      return 'delete';

    }

    // Write (read, download & create access is implied)
    if (getRoles[collectionid]?.[getUser.emailaddress]?.write || getRoles[collectionid]?.['allUsers']?.write) {

      return 'write';

    }

    // Create (read & download access is implied)
    if (getRoles[collectionid]?.[getUser.emailaddress]?.create || getRoles[collectionid]?.['allUsers']?.create) {

      return 'create';

    }

    // Download (read access is implied)
    if (getRoles[collectionid]?.[getUser.emailaddress]?.download || getRoles[collectionid]?.['allUsers']?.download) {

      return 'download';

    }

    // Read
    if (getRoles[collectionid]?.[getUser.emailaddress]?.read || getRoles[collectionid]?.['allUsers']?.read) {

      return 'read';

    }

    // No matches found, reject request
    return 'access-denied';

  } catch (error) {

    console.log(`Function CheckInventoryRole failed to complete, ${error}`);
    return 'access-denied';

  }

}
